// extracted by mini-css-extract-plugin
export default {"Assistance":"Assistance_Assistance__x4OOA","para":"Assistance_para__jRLeY","list":"Assistance_list__+YVsn","view-more":"Assistance_view-more__pj4Kv"};